import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueI18n from 'vue-i18n'
import FlagIcon from 'vue-flag-icon'
import ResultsHub from './results-hub.js'

import slSI from './lang/sl-SI'
import enUS from './lang/en-US'
import hrHR from './lang/hr-HR'

import titleComponent from './components/Title.vue';

Vue.use(VueI18n)
Vue.use(FlagIcon);
Vue.use(ResultsHub)

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'sl-SI',
  messages: {   
    'en-US': enUS,   
    'sl-SI': slSI,
    'hr-HR': hrHR
  }
})

Vue.filter('fileSize', function (value) {
  if (!value) return ''
  if(value > 1000000) return (Math.round(value / 100000)/10) + " MB";
  if(value > 1000) return (Math.round(value / 100) / 10) + " kB";
  return value + " b";
})

Vue.filter('localeToCountry', function (value) {
  return value.split('-')[1];
})

Vue.filter('date', function (value) {
  var date = value.split('T')[0];
  var parts = date.split('-');
  return parts[2]+". "+parts[1]+". "+parts[0];
})

Vue.filter('datetime', function (value) {
  var parts = value.split('T');
  var date = parts[0];
  var time = parts[1];
  parts = date.split('-');
  return parts[2]+". "+parts[1]+". "+parts[0]+" "+time;
})

Vue.component('vue-title', titleComponent);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => {console.log("rendering"); return h(App)}
}).$mount('#app')
